
  import { Vue, Component, Prop } from "vue-property-decorator";

  import { NO_INFORMATION } from "@/data/placeholders";

  @Component
  export default class FormattedDescription extends Vue {
    @Prop({ type: String, default: undefined }) readonly content?: string;

    placeholder: string = NO_INFORMATION;

    get isContentExists(): boolean {
      return Boolean(this.content);
    }

    get formatedDescription(): string[] {
      if (!this.isContentExists) {
        return [];
      }
      return this.content!.split("\n");
    }
  }
